// extracted by mini-css-extract-plugin
export default {"wrap":"dayOffSubordinates_wrap__PB6Wr","vacations__panel":"dayOffSubordinates_vacations__panel__nVv9O"};